import React from 'react';
import './PopupButtons.less';
import { IconButton } from 'components/buttons/IconButton';

export interface IPopupButtonsProps {
  id?: string;
  onOpen: (e: React.MouseEvent, id?: string) => void;
  onClear: (e: React.MouseEvent, id?: string) => void;
  editName?: string;
  clearName?: string;
  disableOpen?: boolean;
  disableClear?: boolean;
}

const POPUP_BUTTONS_CLASS = 'dpc-popup-buttons';

/**
 * Icon buttons for showing a popup _editor_ - these should probably be in editors?
 *
 * Copyright (c) 2019 Decisions ALl Rights Reserved
 */
export function PopupButtons({
  clearName,
  disableClear,
  disableOpen,
  editName,
  id,
  onOpen,
  onClear,
}: IPopupButtonsProps) {
  const open = (e: React.MouseEvent) => onOpen(e, id);
  const clear = (e: React.MouseEvent) => onClear(e, id);

  return (
    <React.Fragment>
      <IconButton
        title={editName || 'Edit'}
        className={`${POPUP_BUTTONS_CLASS}__open`}
        onClick={open}
        iconClassName={`${POPUP_BUTTONS_CLASS}__edit-icon`}
        disabled={disableOpen}
      />
      <IconButton
        title={clearName || 'Clear'}
        className={`${POPUP_BUTTONS_CLASS}__clear`}
        onClick={clear}
        iconClassName={`${POPUP_BUTTONS_CLASS}__clear-icon`}
        disabled={disableClear}
      />
    </React.Fragment>
  );
}
